/* @flow */
/*
 *  Copyright 2017 Adobe Systems Incorporated. All rights reserved.
 *  This file is licensed to you under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License. You may obtain a copy
 *  of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software distributed under
 *  the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 *  OF ANY KIND, either express or implied. See the License for the specific language
 *  governing permissions and limitations under the License.
 *
 */

// import {documentToHtmlString} from '@contentful/rich-text-html-renderer';

class AppInformationModelMapper {
	/**
	 * toPDPModel function
	 * Map inApp/parsed Contentful data to PDPModel
	 * @param {contentfulPDPItems, controllerData, eventHandlerCallback}
	 * @return {object}
	 */
	toAppInformationDialogSections = (contentfulPDPItems: Object) => {
		/*
		const compatibility = {
			actionId: 'modal-tab-select',
			tabId: 'compatibility',
			tabTitle: 'Compatibility',
			tabItems: [
				{
					actionId: 'compatibility-platform-select',
					tabId: 'windows',
					tabTitle: 'Windows',
					tabContent: documentToHtmlString(contentfulPDPItems.compatibilityInfoWin),
				},
				{
					actionId: 'compatibility-platform-select',
					tabId: 'macos',
					tabTitle: 'macOS',
					tabContent: documentToHtmlString(contentfulPDPItems.compatibilityInfoMac)
				},
			],
			currentPlatform: '',
			failingSpecsList: [] // Array of strings to display
		};
		*/

		const languages = contentfulPDPItems.languageList && {
			actionId: 'modal-tab-select',
			tabId: 'languages',
			languageList: contentfulPDPItems.languageList
		};

		// removed compatibility for now
		return {languages};
	}
}

export default new AppInformationModelMapper();
